<template>
  <div class="card card-plain" style="margin-top: -25px;">
      <div class="card-header">
        <h4 class="card-title"> <code class="text-center text-success" style="font-size: 20px">Total information</code></h4>
      </div>
      <div class="card-body" style="margin-top: -25px;">
        <div class="table-responsive" style="overflow: hidden">
          <table class="table">
            <thead class=" text-primary">
            <tr>
              <th class="text-center">
              </th>
              <th class="text-center">
                <code class="text-center text-warning" style="font-size: 16px">Time</code>
              </th>
              <th class="text-center">
                <code class="text-center text-warning" style="font-size: 16px">Payroll</code>
              </th>
            </tr>
            </thead>
            <tbody v-if="totals.all">
            <tr>
              <td>
                Total
              </td>
              <td class="text-center">
                {{totals.all.time}}
              </td>
              <td class="text-center">
                {{formatter.format(totals.all.payroll)}}
              </td>
            </tr>
            <tr>
              <td>
                Paid
              </td>
              <td class="text-center">
                {{totals.paid.time}}
              </td>
              <td class="text-center">
                {{formatter.format(totals.paid.payroll)}}
              </td>
            </tr>
            <tr>
              <td>
                Unpaid
              </td>
              <td class="text-center">
                {{totals.unpaid.time}}
              </td>
              <td class="text-center">
                {{formatter.format(totals.unpaid.payroll)}}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
      props: {
        totals: {
          type: Object ,
          default() {
            return {
              all: {
                time: '0:0:0',
                payroll: '0',
              },
              paid: {
                time: '0:0:0',
                payroll: '0',
              },
              unpaid: {
                time: '0:0:0',
                payroll: '0',
              }
            }
          }
        }
      },
      name: "clocks-total-values",
      data(){
        return{
          formatter:{},
          isMobile:false,
        }
      },
      mounted() {

      },
      created() {
        this.formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        });
        this.isMobile = (/Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent));
      }
    }

</script>

<style scoped>

</style>
